import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { LTApolicyService } from '../../../Model/LTApolicies/ltapolicy.service';

@Component({
  selector: 'app-ltapolicy',
  standalone: true,
  imports: [CommonModule,RouterOutlet,RouterModule,DataTablesModule,LoaderComponent],
  templateUrl: './ltapolicy.component.html',
  styleUrl: './ltapolicy.component.scss'
})
export class LTAPolicyComponent {
  isDisabled: boolean = false;
  ExpenseData : any [] = [];
  TableDatas = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private tooltip : TooltipService,
    private download : DownloadSampleService,
    private toast :  ToastService,
    private ltapolicy: LTApolicyService,
  ) { 
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_ReimbursementRule();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  
  ESS_ReimbursementRule() {
    this.isDisabled = true;
    this.ltapolicy.ESS_ReimbursementRule({ SelectType: 1, ESS_ReimbursementRuleID: 0 }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response.Table);
        this.TableDatas.forEach((element:any) => {
          element.WebESSApplicability = response.Table1.filter((e:any) => e.WebESSApplicabilityId == element.WebESSApplicabilityId)[0].ApplicabilityName
        });
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  exportToExcel() {
    // this.isDisabled = true
    // const data = {
    //   SelectType: 'ExpensePolicyMasterExcel',
    //   Year: ''
    // }
    // this.download.ESS_ExcelDump(data).subscribe(
    //   data => {
    //     this.ExpenseData = data;
    //     if( this.ExpenseData.length > 0){
    //       this.download.exportToExcel(this.ExpenseData, "ExpensePolicies_data");
    //       this.isDisabled = false
    //     }
    //     else{
    //       this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
    //       this.isDisabled = false
    //     }     
    //   });
  }
}
